var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"chartDiv",staticClass:"h-72 lg:mt-6 lg:h-80"})}
var staticRenderFns = []

export { render, staticRenderFns }